import { ArrowRight } from 'lucide-react';
import { trackAssessmentClick } from '../../lib/analytics';

export const CtaBand = () => (
  <section className="cta">
    <div className="container cta-inner">
      <div>
        <p className="eyebrow eyebrow-light">Start the conversation</p>
        <h2>Ready to turn scattered data into decisions you trust?</h2>
      </div>
      <a className="button" href="/analytics-assessment" onClick={() => trackAssessmentClick('home_cta_band')} data-testid="cta-book-btn">
        Book a Free Assessment <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  </section>
);
